import client from "./APIClient"

export default class EmailReminders {
  static update_parameters = (body) => {
    return client("email_reminders", { method: "PUT", body })
  }
}
